import { qnTexts } from '../themes/_palette';

import { qnPrimary } from '../themes/_palette';

export const MuiPagination = {
    styleOverrides: {
        root: {
            "&& .Mui-selected, && .Mui-selected:hover": {
                backgroundColor: 'var(--mui-palette-secondary-main)'
            },
            ".MuiButtonBase-root": {
                color: qnTexts.darkGreyMediumEmphasis,
                fontSize: '12.8px'
            }
        }
    }
}
